
<template>
  <el-dialog title="选择动态" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item>
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "addColumnDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {},
      options: []
    };
  }
};
</script>

